import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  problemTitle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: "1.875em",
    fontWeight: 700,
    borderBottom: "1px solid rgb(230, 230, 230)",
    paddingBottom: 10,
    marginBottom: 0,
    marginTop: 0,
    display: "inline-block",
  },
}));

interface MockProblemTitleProps {
  title: string;
}

export const MockProblemTitle = ({ title }: MockProblemTitleProps) => {
  const classes = useStyles();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <h1 className={classes.problemTitle} id="mock-problem-title">
        {title}
      </h1>
    </Box>
  );
};
